const bindingKeys = ['filename_source', 'display_title_source', 'main_text_source'];

export function typeFormValues(type) {
    return {...type, display_config: {
        main_text_editable: type.main_text_editable,
        ...Object.fromEntries(bindingKeys.map(key => [key, 'input'])),
        ...type.display_config
    }};
}

export function mergeTypeDisplayConfig(type, edits) {
    const original = type.display_config || {};
    const config = {...original, ...edits};
    const hints = {...original.import_sources};
    for (const key of bindingKeys) {
        config[key] = config[key] || 'input';
        if (config[key] !== (original[key] || 'input')) delete hints[key];
    }
    if (original.import_sources) config.import_sources = hints;
    return config;
}
